import { Button, withModalMount } from '@petseo/shared/components/layout/common';
import { IconExternalLink } from '@tabler/icons-react';
import { FormModal } from '@/components/FormModal';
import { RESERVATION_STATE_CONFIG } from '../../constants';
import { formatTimeDisplay, formatDateLong } from '@/utils/datetime';
import type { CalendarReservationDto } from '@/services/api/petseo.client';

interface ReservationQuickViewProps {
  reservation: CalendarReservationDto | null;
  isOpen: boolean;
  onClose: () => void;
  onNavigate: () => void;
}

function ReservationQuickViewContent({ reservation, isOpen, onClose, onNavigate }: ReservationQuickViewProps) {
  if (!isOpen || !reservation) return null;

  const isExternal = reservation.type === 'External';
  const config = isExternal ? RESERVATION_STATE_CONFIG['External'] : RESERVATION_STATE_CONFIG[reservation.state!];

  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="Podgląd rezerwacji" size="sm" closeOnBackdrop>
      <div className="modal-body">
        <div className="row g-3">
          <div className="col-12">
            <label className="form-label text-secondary mb-0">Usługa</label>
            <div className="fw-semibold text-break">{reservation.serviceName || 'Brak nazwy'}</div>
          </div>

          <div className="col-12">
            <label className="form-label text-secondary mb-0">Data</label>
            <div className="d-flex justify-content-between align-items-center gap-2">
              <span className="fw-medium">{formatDateLong(reservation.date)}</span>
              <span className={`badge flex-shrink-0 ${config?.bg ?? 'bg-primary-lt'} ${config?.text ?? 'text-primary'}`}>
                {config?.label ?? reservation.state}
              </span>
            </div>
          </div>

          <div className="col-12">
            <label className="form-label text-secondary mb-0">Godzina</label>
            <div className="fw-medium">
              {formatTimeDisplay(reservation.startTime)} - {formatTimeDisplay(reservation.endTime)}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-link link-secondary me-auto" onClick={onClose}>
          Zamknij
        </button>
        <Button variant="primary" onClick={onNavigate} icon={<IconExternalLink size={16} />}>
          Szczegóły
        </Button>
      </div>
    </FormModal>
  );
}

export const ReservationQuickView = withModalMount(ReservationQuickViewContent);
